export default __webpack_public_path__ + "static/media/next-lesson.aa6a9d29.svg";